module.exports = __webpack_public_path__ + "img/unscoring.182be4fc.png";